import { useState, useEffect } from 'react';
import axios from 'axios';

const UsePostWithReturns = (url, token, postdata) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
  
    useEffect(() => {
      const PostGet = async () => {
        setLoading(true);
        setError(null);
        try { 
          const response = await axios.post( 
            url,
            postdata,
            {
              headers:
              {
                'Authorization': `Basic ${token}`,
                'Content-Type': 'application/json',
              }
            }
          );
          if (response.data) setData(response.data);
  
        } catch (err) {
          setError(err.message || 'An error occurred');
        } finally {
          setLoading(false);
        }
      };
  
      PostGet();
    }, [url, token, postdata]);
    // //Console.log(data, loading, error)
    return { data, loading, error };
  };
  
export default UsePostWithReturns;